const dustjs = require('dustjs');
const Backbone = require('backbone');
const _globalSaleBoxDust = require('store/global/pages/products/_sale_box.dust');

const SaleBoxView = Backbone.View.extend({
	el: '.js-sale-box',

	initialize: function() {
		this.listenTo(Backbone, 'finish:clicked', this.render);
	},

	render: function(data) {
		if (data.sale) {
			dustjs.render(
				_globalSaleBoxDust,
				{
					sale: data.sale,
					participationItemComposite: data.participationItemComposite
				},
				(error, markup) => {
					this.$el.html(markup).show();
				}
			);
		} else {
			this.$el.hide().empty();
		}
	}
});

module.exports = SaleBoxView;
